import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from './TablePoint';
import SearchForm from './SearchForm';

export default class Points extends Component {
    constructor(props) {
        super(props);
        this.state = {
            points: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            removeDirectlyClick: 1,
            total_points: '',
            from: '',
            to: '',
            total: '',
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }
    
    /**
     * Init data and form cash or list cash
     */
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"")).replace(/=/g,"\":\"").replace('%3A', ':') + '"}');
        }
        
        //always get list data
        axios.post('/api/points/search', keySearch_arr).then(response => {
            var result = response.data.data;
            if(response.data.data instanceof Array === false){
                result = Object.keys(response.data.data).map(function(key) {
                    return response.data.data[key];
                });
            }
            this.setState({
                points: result,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
        
        //Count total points
        axios.get('/api/points/total-points?'+ $.param(keySearch_arr)).then(response => {
            this.setState({
                total_points: response.data.total_points,
            });
        });
        
    }
    
    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/points/search', newSearchConditions).then(response => {
            var result = response.data.data;
            if(response.data.data instanceof Array === false){
                result = Object.keys(response.data.data).map(function(key) {
                    return response.data.data[key];
                });
            }
            this.setState({
                points: result,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }
    
    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/points/search', key).then(response => {
            var result = response.data.data;
            if(response.data.data instanceof Array === false){
                result = Object.keys(response.data.data).map(function(key) {
                    return response.data.data[key];
                });
            }
            this.setState({
                points: result,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
        
        //Count total points
        axios.get('/api/points/total-points?'+ $.param(key)).then(response => {
            this.setState({
                total_points: response.data.total_points,
            });
        });
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render () {
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'link_point_edit'},
            {name: 'clientBillFlag', title: 'カテゴリ', isSort: 0, type: 'text'},
            {name: 'created_at', title: '登録日時', isSort: 1, type: 'date_time'},
            {name: 'day_left', title: '残り日数', isSort: 1, type: 'text'},
            {name: 'source', title: '付与元', isSort: 1, type: 'text'},
            {name: 'grant_source_id', title: '付与元ID', isSort: 1, type: 'link_points'},
            {name: 'destination', title: '付与先', isSort: 1, type: 'text'},
            {name: 'destination_id', title: '付与先ID', isSort: 1, type: 'link_points'},
            {name: 'job_apply_status', title: 'ステータス', isSort: 1, type: 'text'},
            {name: 'point', title: '金額', isSort: 1, type: 'convert_to_number_with_zero', prefix:'¥'},
            {name: 'job_id', title: '依頼ID', isSort: 1, type: 'text'},
            {name: 'helper_ticket_id', title: 'チケット申込みID', isSort: 1, type: 'text'},
            {name: 'work_start_date', title: '就業日', isSort: 1, type: 'date'},
            {name: 'payment_method_text', title: '契約形態', isSort: 1, type: 'text'},
            {name: 'memo', title: '摘要', isSort: 0, type: 'text_limit'},
        ];
        const optionTR = {
            conditionColumn: 'day_left'
        }
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">報酬履歴</li>
                            </ol>
                        </nav>
                    </div>
		</div>

		<main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">報酬履歴一覧
                                                <small className="ml-3">現在のTOTAL発行金額 {this.state.total_points ? '¥' + parseInt(this.state.total_points).toLocaleString() : '¥' + 0}</small>
                                            </h4>
                                        </div>
                                        <div className="col text-right">
                                            <a onClick={this.handleRedirect} href="/points/create" className="btn btn-warning btn-space">報酬情報登録</a>
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search-points" aria-expanded="false" aria-controls="search-points">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                                <Table onEdit={this.handleEdit} optionTR={optionTR} onSearch={this.handleSearch} data={this.state.points} header={columns} onSort={this.handleSort} from={this.state.from} to={this.state.to} total={this.state.total}
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} removeClick={this.state.removeDirectlyClick}/>
                            </div>
                        </div>
                    </div>
		</main>
            </React.Fragment>
        );
    }
}
